import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';

/**
 * Testimonials slider
 */
if (document.querySelector('.testimonials-slider')) {
  const carouselNode = document.querySelector('.testimonials-slider');
  const carouselOptions = {
    loop: true,
    skipSnaps: false
  };
  const carouselOptionsAutoplay = { delay: 5000 }; // Options
  const carouselAutoplayRoot = carouselNode => carouselNode.parentElement; // Root node
  const carouselAutoplay = Autoplay(carouselOptionsAutoplay, carouselAutoplayRoot);

  /**
   * Create the slider
   */
  const carousel = EmblaCarousel(carouselNode, carouselOptions, [carouselAutoplay]);

  /**
   * Slider navigation
   */
  function disablePrevNextBtn() {
    carousel.canScrollPrev() ? prevBtn.removeAttribute('disabled') : prevBtn.setAttribute('disabled', 'disabled');

    carousel.canScrollNext() ? nextBtn.removeAttribute('disabled') : nextBtn.setAttribute('disabled', 'disabled');
  }

  const prevBtn = carouselNode.querySelector('.testimonials-slider__nav-prev');
  const nextBtn = carouselNode.querySelector('.testimonials-slider__nav-next');

  prevBtn.addEventListener('click', carousel.scrollPrev, false);
  nextBtn.addEventListener('click', carousel.scrollNext, false);

  carousel.on('select', disablePrevNextBtn);
  carousel.on('init', disablePrevNextBtn);
}

/**
 * ACF page hero carousel
 */
if (document.querySelector('.acf-page-hero__image-wrapper--fading')) {
  let current = 0;
  const slidesWrapper = document.querySelector('.acf-page-hero__image-wrapper--fading');
  let slides = slidesWrapper.getElementsByTagName('img');

  setInterval(function () {
    for (var i = 0; i < slides.length; i++) {
      slides[i].style.opacity = 0;
    }

    current = current != slides.length - 1 ? current + 1 : 0;
    slides[current].style.opacity = 1;
  }, 3000);
}
